import React from "react";
import PropTypes from "prop-types";
import LabelAndDots from "./LabelAndDots";

const TextAreaField = ({
  field,
  formData,
  handleChange,
  readOnly,
  validationErrors,
  fieldTransformer,
}) => {
  // Determine if the field should be read-only.
  const isFieldReadOnly =
    readOnly || field.forceReadOnly || field.key === "managementId";
  const errorClass = validationErrors[field.key] ? "border border-red-500" : "";

  return (
    <div className="flex flex-col w-full" style={{ gridColumn: "span 2" }}>
      <div className="flex items-center w-full">
        <label
          className="flex items-center text-sm"
          style={{
            lineHeight: "1.2",
            whiteSpace: "nowrap",
            overflow: "hidden",
            width: "12.5em",
          }}
        >
          <LabelAndDots
            label={field.label}
            tooltip={field.tooltip}
            required={field.required && !!validationErrors[field.key]}
          />
        </label>
        <textarea
          name={field.key}
          className={`text-sm p-1 flex-grow ${errorClass} ${
            isFieldReadOnly
              ? "bg-gray-100 cursor-not-allowed"
              : "border border-gray-700"
          }`}
          value={
            fieldTransformer
              ? fieldTransformer(formData[field.key])
              : formData[field.key] || ""
          }
          onChange={handleChange}
          readOnly={isFieldReadOnly}
          rows={field.rows || 2}
          style={{
            resize: "vertical",
            pointerEvents: isFieldReadOnly ? "none" : "auto",
            userSelect: isFieldReadOnly ? "none" : "auto",
          }}
        />
      </div>
      {validationErrors[field.key] && (
        <div className="text-red-500 text-sm mt-1 text-end">
          {validationErrors[field.key]}
        </div>
      )}
    </div>
  );
};

TextAreaField.propTypes = {
  field: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  validationErrors: PropTypes.object,
  fieldTransformer: PropTypes.func,
};

export default TextAreaField;
